import React, { memo, useEffect, useState } from 'react'
import { PrimeIcons } from 'primereact/api';
import { Portal } from 'primereact/portal';

const loadingRef = React.createRef();

export const onShowLoading = (showMessage = false, message = '') => {
    if (loadingRef.current) {
        loadingRef.current.setLoading(true);
        loadingRef.current.setShowMessage(showMessage);
        loadingRef.current.setMessage(message);
    }
}

export const onHideLoading = () => {
    if (loadingRef.current) {
        loadingRef.current.setLoading(false);
        loadingRef.current.setShowMessage(false);
        loadingRef.current.setMessage('');
    }
}

const LoadingProvider = () => {
    const [loading, setLoading] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        loadingRef.current = {
            setLoading,
            setShowMessage,
            setMessage
        };
    }, []);

    const element = (
        <div className='position-absolute justify-content-center align-items-center bg-black-alpha-40 flex-column'
             style={{ display: loading ? 'flex' : 'none', zIndex: 10000, inset: 0 }}>

            <i style={{ fontSize: '8vh', color: "#36a1e1" }} className={PrimeIcons.SPINNER + " pi-spin mb-3"}></i>

            {showMessage && message && (
                <div style={{
                    fontSize: '1.2rem',
                    color: 'white',
                    background: 'rgba(0,0,0,0.5)',
                    padding: '1rem 2rem',
                    borderRadius: '8px',
                    textAlign: 'center',
                    maxWidth: '80%'
                }}>
                    {message}
                </div>
            )}
        </div>
    );

    return loading && <Portal element={element} visible />;
};

export default memo(LoadingProvider);
